export class NewQuote {
portfolioId: number;
portfolioName: string;
status: number;
dealerId: string;

modelDesc: string;
modelActiveFlag: number;
newQuotFlag: number;
variantDesc: string;
variantActiveFlag: number;
exShowroomPrice: number;

newVehBrandId: string = "";
newVehBrandName: string;

newVehModelId: string;
newVehModelName: string;

newVehVariantId: string;
newVehVarName: string;

isNewCar ?: boolean = true;

//usedVehBank: string;
usedVehBrandId:string;

userId: string = "";

quotationId = "";
custId="";

statusId ="";

constructor() {

}
} 
